<afp-label-card>
  <div class="personSuspentionCard-container-titleBar">
    <span id="personSuspensionCard-span-title" class="title">{{ personSuspensionDetail.suspensionReason.name }}</span>
    <app-person-suspension-status-chip [status]="getSuspensionStatus()" [effectiveAt]="personSuspensionDetail.effectiveAt">
    </app-person-suspension-status-chip>
    <span
      *ngIf="!personSuspensionDetail.active && !personSuspensionDetail.expired"
      id="personSuspensionCard-text-suspensionDeactivatedBy"
      class="text-suspensionDeactivatedBy"
    >
      {{ getDeactivatedByDisplay() }}
    </span>
  </div>

  <div id="personSuspensionCard-section-suspensionDetails" class="personSuspensionCard-section-suspensionDetails column">
    <div class="row">
      <div class="column flex-1">
        <div id="personSuspensionCard-label-suspentionStartDate" class="label-suspensionDetail">Start Date</div>
        <div id="personSuspensionCard-text-suspentionStartDateValue" class="text-suspensionDetail">
          {{ getStartDate() }}
        </div>
      </div>
      <div class="column flex-1">
        <div id="personSuspensionCard-label-suspentionEndDate" class="label-suspensionDetail">End Date</div>
        <div id="personSuspensionCard-text-suspentionEndDateValue" class="text-suspensionDetail">{{ getEndDate() }}</div>
      </div>

      <div class="column flex-1">
        <div id="personSuspensionCard-label-suspentionCreatedBy" class="label-suspensionDetail">Created By</div>
        <div id="personSuspensionCard-text-suspentionCreatedByValue" class="text-suspensionDetail">
          {{ getCreatedByDisplay() }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="column flex-1">
        <div id="personSuspensionCard-label-description" class="label-suspensionDetail">Description</div>
        <p id="personSuspensionCard-text-descriptionValue" class="text-suspensionDetail">{{ personSuspensionDetail.note }}</p>
      </div>
      <div class="button-container">
        <afp-button
          *ngIf="hasRemovePermission && personSuspensionDetail.active && !personSuspensionDetail.expired"
          id="personSuspensionCard-button-removeSuspension"
          variant="primary"
          (click)="handleRemoveSuspension()"
        >
          Remove Suspension
        </afp-button>
      </div>
    </div>
  </div>
</afp-label-card>
